import { render, staticRenderFns } from "./PatientMedicalRecordsList.vue?vue&type=template&id=6b0ea8bf&scoped=true&"
import script from "./PatientMedicalRecordsList.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicalRecordsList.vue?vue&type=style&index=0&id=6b0ea8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ea8bf",
  null
  
)

export default component.exports